import * as yup from 'yup';

import {TFunction} from 'i18next';

export const NAME_MAX_LENGTH = 50;
const NAME_MIN_LENGTH = 3;
export const EMAIL_MAX_LENGTH = 50;
const PHONE_REGEX_PATTERN =
  /^((\+?[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const OdooCompanyValidationSchema = (t: TFunction) =>
  yup.object({
    name: yup
      .string()
      .min(
        NAME_MIN_LENGTH,
        t('validation:min_length', {
          name: t('name'),
          min: NAME_MIN_LENGTH
        }) || undefined
      )
      .max(
        NAME_MAX_LENGTH,
        t('validation:max_length', {
          name: t('name'),
          max: NAME_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('name')
        }) || undefined
      ),
    address: yup.object().shape({
      street: yup.string().required(
        t('validation:is_required', {
          name: t('street')
        }) || undefined
      ),
      streetNumber: yup.string().required(
        t('validation:is_required', {
          name: t('street_number')
        }) || undefined
      ),
      postalCode: yup.string().required(
        t('validation:is_required', {
          name: t('postal_code')
        }) || undefined
      ),
      city: yup.string().required(
        t('validation:is_required', {
          name: t('city')
        }) || undefined
      ),
      country: yup.string().required(
        t('validation:is_required', {
          name: t('country')
        }) || undefined
      )
    }),
    use19vat: yup.boolean().required(
      t('validation:is_required', {
        name: t('use19vat_info')
      }) || undefined
    ),
    email: yup
      .string()
      .email(t('validation:email_invalid') || undefined)
      .required(
        t('validation:is_required', {
          name: t('email')
        }) || undefined
      ),
    phoneNumber: yup
      .string()
      .matches(PHONE_REGEX_PATTERN, t('validation:phone_invalid') || undefined)
      .notRequired(),

    website: yup.string().url(t('validation:website_invalid')).notRequired()
  });

export type UserSchemaData = yup.InferType<
  ReturnType<typeof OdooCompanyValidationSchema>
>;

export default OdooCompanyValidationSchema;
